import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IonIcon } from "@ionic/angular/standalone";
import { CabIconName } from "./cab-icon.type";

const ICON_SIZE = {
  "5xl": 128,
  "4xl": 90,
  "3xl": 64,
  "2xl": 45,
  xl: 32,
  lg: 24,
  md: 20,
  sm: 16,
  xs: 12,
} as const;

type IconSize = keyof typeof ICON_SIZE;

@Component({
  selector: "cab-icon",
  templateUrl: "./cab-icon.component.html",
  styleUrls: ["./cab-icon.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonIcon],
})
export class CabIconComponent {
  @Input({ required: true }) name: CabIconName;
  @Input() size: IconSize = "md";

  get iconSrc() {
    return `assets/cab-icons/${this.name}.svg`;
  }

  getIconSize(): number {
    return ICON_SIZE[this.size];
  }
}
